// @flow

import { useMutation } from 'react-query';
import type { UseMutationOptions } from 'react-query';
import GrossRentsService from '../../../services/grossRentsService';
import useAbortController from '../../../hooks/useAbortController';

const grossRentsService = new GrossRentsService();

type CancelGrossRentCertificationVariables = {
  affordableQualificationId: string,
};

const useCancelGrossRentCertificationMutation = ({
  propertyId,
  organizationId,
  options,
}: {
  propertyId: string,
  organizationId: string,
  options?: UseMutationOptions<
    Object,
    mixed,
    CancelGrossRentCertificationVariables,
    mixed,
  >,
}) => {
  const abortControllerOptions = useAbortController();

  return useMutation(
    async ({
      affordableQualificationId,
    }: CancelGrossRentCertificationVariables) => {
      return grossRentsService.cancelGrossRentCertification(
        organizationId,
        propertyId,
        affordableQualificationId,
        abortControllerOptions,
      );
    },
    options,
  );
};

export default useCancelGrossRentCertificationMutation;
